import React, { ChangeEvent } from 'react';
import { cn } from '../../utils/cn';

interface SearchFieldProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
}

export const SearchField: React.FC<SearchFieldProps> = ({
  placeholder = 'Search...',
  value,
  onChange,
  className,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div className={cn('relative w-full', className)}>
      <div className="absolute left-3 top-1/2 -translate-y-1/2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          className="text-grey-medium"
        >
          <path
            d="M8.14951 1C11.905 1 14.9492 4.04436 14.9493 7.7998C14.9493 11.5553 11.905 14.5996 8.14951 14.5996C6.54133 14.5995 5.0646 14.0398 3.90048 13.1064C3.89348 13.114 3.88735 13.1225 3.87997 13.1299L2.28036 14.7295C1.98747 15.0224 1.51271 15.0224 1.21982 14.7295C0.92712 14.4366 0.92699 13.9618 1.21982 13.6689L2.81943 12.0693C2.82679 12.062 2.8343 12.0548 2.84189 12.0479C1.90913 10.8839 1.3497 9.40747 1.3497 7.7998C1.34981 4.04455 4.3943 1.00032 8.14951 1ZM8.14951 2.5C5.22273 2.50032 2.84981 4.87298 2.8497 7.7998C2.8497 10.7267 5.22267 13.0993 8.14951 13.0996C11.0766 13.0996 13.4493 10.7269 13.4493 7.7998C13.4492 4.87279 11.0765 2.5 8.14951 2.5Z"
            fill="currentColor"
          />
        </svg>
      </div>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        className="h-10 w-full pl-10 pr-4 text-body-lg text-grey-main placeholder-grey-medium bg-transparent outline-none border-b transition-all border-grey-sky"
      />
    </div>
  );
};
